module.exports = __webpack_public_path__ + "asset/image-download-screenshot-5532c707ecd2d5ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/download-screenshot.png
// module id = HCns
// module chunks = 1